import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { api, state, ui } from '../../../../../interfaces/interfaces';
import useDebugInformation from '../../../../../hooks/useDebugInformation';
import StorageUtils from '../../../../../services/storage';
import bookingCycleMgr from '../../../../../services/bookingCycleMgr';
import FollowUpDialog from './FollowUpDialog';
import EnquiryTabs from './EnquiryTabs';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { useAppSelector } from "@store/hooks";

const name = 'CallMeBackDialog';

interface Props {
    parent: string
}

export const handleClose = () => {
    ui.CallMeBacksModal = false;
    removeLock();
};

const handleFollowUp = (history: any) => {
    ui.FollowUpDialogModal = true;
}

const showAuth = () => {
    ui.CallMeBackAuthDialogModal = true;
}

const bookNewJob = (navigate: NavigateFunction) => {
    bookingCycleMgr.setBooking("callMeBack", ui.CallMeBacksModalData.accountCode, 0);
    StorageUtils.saveToStorage({ type: "local", store: "state", key: "callMeBack", value: { ...ui.CallMeBacksModalData } });
    api.fetchCallMeBacksSetAsBooked({
        leadId: ui.CallMeBacksModalData.leadId,
        userId: state.UserId,
    }).then(() => {
        handleClose();
        navigate("/switchboard", { replace: true, state: { accountCode: ui.CallMeBacksModalData.accountCode, newBooking: true, delayedLoad: true } });
    });
}
export const removeLock = async () => {
    if (ui.CallMeBacksModalData?.leadId) {
        await api.fetchGetCallMeBackUnlock({
            id: ui.CallMeBacksModalData.leadId,
            objectTypeId: 3
        })
    }
}

const FormDialog: React.FC<Props> = ({ parent }) => {
    const open = useAppSelector(({ ui }) => ui.CallMeBacksModal)
    const data = useAppSelector(({ ui }) => ui.CallMeBacksModalData)
    const navigate = useNavigate()
    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { open })

    return (

        <Dialog open={open} onClose={handleClose}
            fullWidth={true}
            maxWidth="md"
        >
            <FollowUpDialog leadId={data.leadId} />
            <DialogTitle>Enquiry Info</DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    Please follow up this enquiry
                </DialogContentText>
                <EnquiryTabs parent={debugName} />
            </DialogContent>
            <DialogActions>
                <Button variant='contained' color='error' onClick={handleClose}>Close</Button>
                <Button variant='contained' color='primary' onClick={() => bookNewJob(navigate)}>Book new job</Button>
                <Button variant='contained' color='primary' onClick={handleFollowUp}>Follow Up</Button>
                <Button variant='contained' color='error' onClick={showAuth}>Cancel Enquiry</Button>
            </DialogActions>
        </Dialog>
    );
}

FormDialog.displayName = name;

export default React.memo(FormDialog);